/* global console */

/**
 * Safe replacement for JSON.parse. It should not fail.
 * @param str
 * @returns {*}
 */
export function safeJSONparse(str) {
    if (!str || typeof str !== "string") {
        return {};
    }

    try {
        return JSON.parse(str);
    } catch (e) {
        /* ignore error */
        console.log("Failed to parse JSON", e, str); // eslint-disable-line no-console
    }

    return {};
}

export function asJSON(json) {
    if (!json) {
        return {};
    }

    if (typeof json === "string") {
        return safeJSONparse(json);
    } else {
        return json;
    }
}
